import l from "./td-longtail-vue-components121.js";
/* empty css                              */
import n from "./td-longtail-vue-components98.js";
var i = function() {
  var t = this, o = t._self._c, e = t._self._setupProxy;
  return o("div", { staticClass: "video-player" }, [o(e.PlayPauseButton, { staticClass: "video-player__play-button", class: {
    "video-player__play-button--center": t.playButtonCentered && e.doShowPlayButton,
    "video-player__play-button--pause": !e.doShowPlayButton
  }, attrs: { primary: "", large: t.playButtonCentered && e.doShowPlayButton, "aria-label": e.doShowPlayButton ? t.playButtonAriaLabel : t.pauseButtonAriaLabel, title: e.doShowPlayButton ? "Video abspielen" : "Video pausieren" }, on: { input: e.togglePlay }, model: { value: e.isPlaying, callback: function(a) {
    e.isPlaying = a;
  }, expression: "isPlaying" } }), o("video", { ref: "videoElement", staticClass: "video-player__video", attrs: { autoplay: t.autoplay && !e.isReducedMotion, controls: t.controls, loop: t.loop, playsinline: t.playsinline, poster: e.posterSrc, preload: t.preload, "aria-label": t.videoAriaLabel }, domProps: { muted: t.muted }, on: { ended: function(a) {
    e.isPlaying = !1;
  }, pause: function(a) {
    e.isPlaying = !1;
  }, play: function(a) {
    e.isPlaying = !0;
  }, click: e.togglePlay } }, [t._t("default", function() {
    return [o("source", { attrs: { src: e.videoSrc, type: `video/${e.type}` } })];
  }), t._v(" Your browser does not support the video tag. ")], 2)], 1);
}, r = [], s = /* @__PURE__ */ n(
  l,
  i,
  r,
  !1,
  null,
  "675af77e"
);
const c = s.exports;
export {
  c as default
};
